import { Injectable } from '@angular/core';
import { SwitchingWorkState, WorkStates } from '@vendasta/rx-utils/work-state';
import { DomainService, SenderType } from '@vendasta/email';
import { mapTo } from 'rxjs/operators';

export interface Inputs {
  senderType: SenderType;
  senderId: string;
  emailSenderInfo: {
    username: string;
    replyTo: string;
  };
}

export interface SuccessPayload {
  senderEmail: string;
  replyToEmail: string;
}

@Injectable({ providedIn: 'root' })
export class SenderInfoResetService {
  private readonly _state = new SwitchingWorkState<Inputs, SuccessPayload>((i: Inputs) => {
    const domain = this.getDefaultDomain();
    const payload: SuccessPayload = {
      senderEmail: `${i.emailSenderInfo.username}@${domain}`,
      replyToEmail: i.emailSenderInfo.replyTo,
    };
    return this.domain
      .changeForSender(i.senderType, i.senderId, domain, i.emailSenderInfo.username, i.emailSenderInfo.replyTo)
      .pipe(mapTo(payload));
  });
  readonly state: WorkStates<SuccessPayload> = this._state;

  constructor(private readonly domain: DomainService) {}

  getDefaultDomain(): string {
    return 'smblogin.com';
  }

  updateSenderInfo(i: Inputs): void {
    this._state.startWork(i);
  }
}
